export default "__VITE_ASSET__CXugIGvV__"